var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "details-view" }, [
    _c("div", { staticClass: "main-content accrueReportWeekly" }, [
      _c(
        "div",
        {
          staticClass: "section form-column",
          staticStyle: { width: "1150px" }
        },
        [
          _c(
            "el-form",
            {
              staticStyle: { "margin-top": "5px" },
              attrs: {
                inline: true,
                "label-width": "60px",
                "label-position": "right"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { "label-width": "100px", label: "COPY DATE" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "140px" },
                      attrs: { no: "copyDate" },
                      model: {
                        value: _vm.copyDate,
                        callback: function($$v) {
                          _vm.copyDate = $$v
                        },
                        expression: "copyDate"
                      }
                    },
                    _vm._l(_vm.copyDates, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: _vm.copyDateLabelFun(item),
                          value: item
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_BranchCMP") } },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "150px" },
                    attrs: {
                      no: "branchIds",
                      "select-type": _vm.selectTypeNames.basic_data_Office,
                      multiple: true,
                      clearable: false,
                      filterable: "",
                      "default-multiple-value": _vm.branchIds,
                      "tag-value": "officeId",
                      "tag-name": "code",
                      "filter-tag-names": [
                        "englishName",
                        "chineseName",
                        "code"
                      ],
                      cache: false,
                      "static-options": _vm.currentOfficeList,
                      placeholder: " "
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.currentOfficeIdChange(p.value)
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_Department") } },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "240px" },
                    attrs: {
                      no: "deptIds",
                      "select-type": _vm.selectTypeNames.basic_data_Department,
                      multiple: true,
                      filterable: "",
                      "default-multiple-value": _vm.deptIds,
                      "tag-value": "departmentId",
                      "tag-name": _vm.isZh ? "chineseName" : "englishName",
                      "filter-tag-names": [
                        "englishName",
                        "chineseName",
                        "code"
                      ],
                      cache: false,
                      "static-options": _vm.currentDeptList,
                      placeholder: " "
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.deptIds = p.value
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticStyle: { "margin-bottom": "15px!important" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "dataExport", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.toDataExport()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DataExport")))]
                  ),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "13px",
                        color: "orange",
                        "margin-left": "25px"
                      }
                    },
                    [_vm._v(_vm._s(_vm.lastWeeklyDate))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }